













































import { GroupLevelAttributeValue } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';

@Component({})
export default class CourseTitleAttributeField extends Vue {
  @PropSync('courseName') syncedCourseTitle!: string;
  @Prop() attributeValue!: GroupLevelAttributeValue;
  @Prop({ default: false }) isSettings!: boolean;
  @Prop() fieldClasses!: any;
  @Prop() deleteAttribute!: () => void;
  @Prop() updateAttributeValue!: (attribute: GroupLevelAttributeValue) => void;
  @Prop() toggleAttributeRequire!: (
    attribute: GroupLevelAttributeValue
  ) => void;
  @Prop() editAttribute!: (attribute: GroupLevelAttributeValue) => void;

  showField: boolean = false;
  labelErrorMsg: string = '';
  fieldErrorMsg: string = '';

  // show title value input field with extra listener
  valueIsCourseName: boolean =
    (this.attributeValue.isTitle as boolean) && !this.isSettings;

  // Computed property so changes from the value from parent component are synced
  get isRequired() {
    return this.attributeValue.groupLevelAttributeSpec.isRequired;
  }

  @Watch('syncedCourseTitle')
  assignCourseTitle() {
    // watch the synced title and assign course title
    if (this.valueIsCourseName) {
      this.attributeValue.value = this.syncedCourseTitle;
    }
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('isRequired', { immediate: true })
  updateErrorState() {
    if (this.isSettings) {
      this.validateRequiredFieldValues();
      return;
    }

    this.attributeValue.hasFieldError = true;
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('attributeValue.value')
  validateRequiredFieldValues() {
    // validate null / empty values for required fields
    if (!this.attributeValue.value) {
      this.fieldErrorMsg = 'Title cannot be empty.';
      this.attributeValue.hasFieldError = true;
      this.updateAttributeValue(this.attributeValue);
      return;
    }

    this.fieldErrorMsg = '';
    this.attributeValue.hasFieldError = false;
    this.updateAttributeValue(this.attributeValue);
  }
}
